import BaseApi from '@core/api/model';

export class AgreementApi extends BaseApi {
    static resource = 'agreements';
}

export default AgreementApi;
